import { gql } from "graphql-request";

export const LOAN_APPLICATION_EXTENDED_FRAGMENT = gql`
  fragment LoanApplicationExtendedFragment on LoanApplicationType {
    id
    state
    requestedLoanAmount
    requestedPaybackTimeMonths
    biddingEndsAt
    eligibleForLeasingBids
    product
    advisoryAcceptedAt
    adviceCategory
    isDigitalAdvice
    initialNumberOfAttractivenessImprovements
    applicationAttractiveness
    customerPreferredRate
    alternativeRate
    verificationFailureReasons
    forecastApprovedProbability
    latestDuplicatedApplicationInfo {
      id
      submittedAt
      numBids
    }

    applicationImprovements {
      field
      displayText
      type
    }
    assignedToAdminUser {
      id
      email
      firstName
      lastName
      mobilePhoneNumber
      profileImage {
        lowResolutionUrl
      }
    }
    contactPerson {
      id
      ssn
      firstName
      lastName
      email
    }
    triageFields
    previewFields
    applyingCompany {
      id
      customerCompany {
        id
        name
        organisationNumber
        typeDisplayName
        incorporationDate
      }
      boardMembers {
        ssn
        firstName
        lastName
        roles {
          roleCode
          roleName
        }
      }
    }
  }
`;
